<template>
  <div class="commission-types">
    <!-- 新增的对话框 -->
    <el-dialog
      center
      width="1200px"
      title="更新记录"
      :visible.sync="dialogTableVisible"
      @opened="getLoad"
      @close="handleClose()"
    >
      <h4 style="padding: 20px 0">当前楼盘：{{ houseName }}</h4>
      <el-form
        :model="ruleForm"
        :rules="rules"
        :inline="true"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="更新时间">
          <el-form-item prop="dateTime">
            <!-- :picker-options="pickerOptions" -->
            <el-date-picker
              v-model="dateTime"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd HH:mm:ss"
              align="right"
            >
            </el-date-picker>
          </el-form-item>
        </el-form-item>
        <el-form-item label="操作人" prop="userId">
          <el-select
            class="select"
            v-model="updateBy"
            filterable
            remote
            placeholder="请输入操作人"
            :remote-method="searchUser"
            @change="checkItem"
            clearable
            :loading="loading"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="handleUserDecrypt(item.label, item.isShowAllPhone)"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="复核人" prop="reviewMan">
          <el-select
            class="select"
            v-model="reviewMan"
            filterable
            remote
            placeholder="请输入操作人"
            :remote-method="searchReviewMan"
            @change="handleSelectReviewMan"
            clearable
            :loading="loading"
          >
            <el-option
              v-for="item in reviewManList"
              :key="item.value"
              :label="handleUserDecrypt(item.label, item.isShowAllPhone)"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" style="margin: 0 10px" @click="handleReset"
            >重置</el-button
          >
          <el-button type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
      <el-table
        :data="tableData"
        style="width: 100%"
        :row-class-name="tableRowClassName"
      >
        <el-table-column prop="updateTime" label="更新时间" width="180">
        </el-table-column>
        <el-table-column
          prop="validityCalculateType"
          label="结算方式"
          width="180"
        >
          <template slot-scope="scope">
            <span>{{
              scope.row.validityCalculateType == 1
                ? '固定金额佣金'
                : '楼盘总价*点数'
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="有效期" width="230">
          <template slot-scope="scope">
            <div>开始时间：{{ scope.row.validityStartTime }}</div>
            <div>结束时间：{{ scope.row.validityEndTime }}</div>
          </template>
        </el-table-column>
        <el-table-column label="售佣金金额/比例">
          <template slot-scope="scope">
            <span>{{
              scope.row.validityCalculateType == 1
                ? scope.row.validityFixedBonus
                : scope.row.validityBonusPoint
            }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="rentBasePoint" label="租佣金金额/基数">
        </el-table-column>
        <el-table-column prop="updateName" label="操作人">
          <template slot-scope="scope">
            <span>{{ handledecrypt(scope.row.updateName) || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="updateName" label="操作人账号">
          <template slot-scope="scope">
            <span>{{ handledecrypt(scope.row.updateMobile) || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="reviewMan" label="复核人">
          <template slot-scope="scope">
            <span>{{ handledecrypt(scope.row.reviewMan) || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="reviewMan" label="复核状态">
          <template slot-scope="scope">
            <!--  0：未复核 1：已复核，2：驳回 -->
            <span>{{ checkStatus[scope.row.reviewStatus].label }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="reviewOpinion" label="复核备注">
          <template slot-scope="scope">
            <el-popover
              v-if="scope.row.reviewOpinion"
              placement="top-start"
              title=""
              width="200"
              trigger="hover"
              :content="scope.row.reviewOpinion"
            >
              <div class="popover-remark" slot="reference">
                {{ scope.row.reviewOpinion }}
              </div>
            </el-popover>
            <span v-else>--</span>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <Pagination
        ref="Pagination"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      />
    </el-dialog>
  </div>
</template>
<script>
import Pagination from '@/components/Pagination2'; // 分页2
import { getCommisionRecordApi } from '@/api/houseApi.js';
import { getUserModelApi } from '@/api/user.js';
// import { mapGetters } from 'vuex';
import { decrypt } from '@/utils/encryp';
export default {
  components: {
    Pagination,
  },
  data() {
    return {
      houseId: '',
      houseRateId: '',
      houseName: '',
      dateTime: '',
      updateBy: '',
      reviewMan: '', //复核人
      pageSize: 20,
      pageIndex: 1,
      dialogTableVisible: false,
      loading: false,
      options: [],
      reviewManList: [],
      ruleForm: {
        name: '',
        region: '',
      },
      pickerOptions: {
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              console.log(111);
              picker.$emit('pick', new Date());
            },
          },
          {
            text: '昨天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', date);
            },
          },
          {
            text: '一周前',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            },
          },
        ],
      },
      rules: {},
      tableData: [],
      checkStatus: {
        0: {
          label: '未复核',
        },
        1: {
          label: '已复核',
        },
        2: {
          label: '驳回',
        },
      },
    };
  },
  // computed: {
  //   ...mapGetters(['paginObj']),
  // },
  // watch: {
  //   paginObj: 'getLoad',
  // },
  mounted() {},
  methods: {
    // 处理解密
    handledecrypt(str) {
      if (!str) return;
      return decrypt(str);
    },
    // 关闭弹框
    handleClose() {
      this.dateTime = null;
      this.updateBy = '';
      this.$refs['ruleForm'].resetFields();
    },
    // 初始化数据
    getLoad() {
      try {
        this.listLoading = true;
        getCommisionRecordApi({
          pageSize: this.pageSize,
          pageIndex: this.pageIndex,
          houseId: this.houseId,
          houseRateId: this.houseRateId,
          startTime: this.dateTime ? this.dateTime[0] : '',
          endTime: this.dateTime ? this.dateTime[1] : '',
          updateBy: this.updateBy || '',
          reviewMan: this.reviewMan || '',
        }).then((res) => {
          this.tableData = res.data.dataList;
          this.listLoading = false;
          this.$refs.Pagination.pageSize = res.data.pageSize;
          this.$refs.Pagination.pageIndex = res.data.pageIndex;
          this.$refs.Pagination.totalCount = res.data.totalCount;
        });
      } catch (e) {
        window.console.log(e);
      }
    },
    // 列表样式
    tableRowClassName({ rowIndex }) {
      if (rowIndex === 1) {
        return 'warning-row';
      } else if (rowIndex === 3) {
        return 'success-row';
      }
      return '';
    },
    // 查询
    onSubmit() {
      console.log('time', this.dateTime);
      console.log('name', this.updateBy);
      this.getLoad();
    },
    // 重置
    handleReset() {
      this.dateTime = null;
      this.options = [];
      this.updateBy = '';
      this.reviewManList = [];
      this.reviewMan = '';
      this.getLoad();
    },

    // 搜索用户
    async searchUser(val) {
      this.loading = true;
      const areaId = localStorage.getItem('areaId')
        ? JSON.parse(localStorage.getItem('areaId')).areaId
        : '';
      let res = await getUserModelApi({ userName: val, areaId });
      this.loading = false;
      this.options = JSON.parse(
        JSON.stringify(res.data.dataList)
          .replace(/nickName/g, 'label')
          .replace(/userId/g, 'value')
      );
    },
    handleUserDecrypt(str, isShowAll) {
      if (!str) return;
      let index1 = str.indexOf('(');
      let index2 = str.indexOf(')');
      let str2 = str.substring(index1 + 1, index2);
      let str1 = str.replace(`(${str2})`, '');
      return `${decrypt(str1)}(${
        isShowAll
          ? decrypt(str2)
          : decrypt(str2).replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
      })`;
    },
    // 搜索列表下拉选中
    checkItem() {},
    // 搜索复核人
    async searchReviewMan(val) {
      this.loading = true;
      const areaId = localStorage.getItem('areaId')
        ? JSON.parse(localStorage.getItem('areaId')).areaId
        : '';
      let res = await getUserModelApi({ userName: val, areaId });
      this.loading = false;
      this.reviewManList = JSON.parse(
        JSON.stringify(res.data.dataList)
          .replace(/nickName/g, 'label')
          .replace(/userId/g, 'value')
      );
    },
    handleSelectReviewMan() {},
    // 页面变化
    handleCurrentChange(obj) {
      this.pageIndex = obj.pageIndex;
      this.getLoad();
    },
    // 分页改变页面数据
    handleSizeChange(obj) {
      this.pageSize = obj.pageSize;
      this.getLoad();
    },
  },
};
</script>
<style>
.el-table .warning-row {
  background: oldlace;
}

.el-table .success-row {
  background: #f0f9eb;
}
.popover-remark {
  width: 60px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  cursor: pointer;
}
</style>
